import { Injectable } from "@angular/core";
//import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/compat/firestore';
import { Firestore, collection, collectionData, orderBy, query } from '@angular/fire/firestore';
import { Section } from '../models/section';
import { Observable } from "rxjs";
import { map  } from 'rxjs/operators';
@Injectable()
export class SectionService {

    //private sectionCollection: AngularFirestoreCollection<Section>;
    listOfSections: Observable<Section[]>;

    constructor(private db: Firestore) {
        // const settings = { timestampsInSnapshots: true};
        // db.firestore.settings(settings);
    }

    /*Get all sections filtered by year */
    getByYear() {

        const sectionCollectionRef = collection(this.db, 'sections');
        const sectionQuery = query(sectionCollectionRef, orderBy('order', 'asc'));

        // this.sectionCollection = this.db.collection<Section>('sections',
        //     ref => {
        //         return ref.orderBy("order", "asc")
        //     }
        // );

        return collectionData(sectionQuery, { idField: 'id' }) as Observable<Section[]>;

        // return this.sectionCollection
        // .snapshotChanges()
        // .pipe(
        //   map(actions => {
        //     return actions.map(a => {
        //         const data = a.payload.doc.data() as Section
        //         const id = a.payload.doc.id;
        //         return { id, data }
        //     })
        // })
        // )

    }
}
